/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpResponse } from '@app/core';
import { CheckInOut } from '@app/reports/check-in-out/check-in-out.model';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';

export interface CheckInOutIndexFilters {
  user_id?: number;
  start_date?: string;
  end_date?: string;
}

export interface CheckInOutCorrectionPayload {
  check_in_at: string;
  check_out_at: string;
  edit_note: string;
}

@Injectable({ providedIn: 'root' })
export class CheckInOutService {
  constructor(private http: HttpClient) {}

  index(filters: CheckInOutIndexFilters = {}): Observable<PaginatedResponse> {
    let params = new HttpParams().set('limit', '1000').set('include', 'user,resolvedBy');

    if (filters.user_id) {
      params = params.set('filter[user_id]', filters.user_id.toString());
    }
    if (filters.start_date) {
      params = params.set('start_date', filters.start_date);
    }
    if (filters.end_date) {
      params = params.set('end_date', filters.end_date);
    }

    return this.http.get('v1/check_in_out', { params }).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((item: any) => new CheckInOut().deserialize(item));
        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  status(): Observable<CheckInOut> {
    return this.http
      .get('v1/check_in_out/status')
      .pipe(map((response: HttpResponse) => new CheckInOut().deserialize(response.data)));
  }

  toggle(): Observable<CheckInOut> {
    return this.http
      .post('v1/check_in_out/toggle', {})
      .pipe(map((response: HttpResponse) => new CheckInOut().deserialize(response.data)));
  }

  correctInterval(
    recordId: number,
    intervalIndex: number,
    payload: CheckInOutCorrectionPayload
  ): Observable<CheckInOut> {
    return this.http
      .put(`v1/check_in_out/${recordId}/intervals/${intervalIndex}`, payload)
      .pipe(map((response: HttpResponse) => new CheckInOut().deserialize(response.data)));
  }
}
